<template>
  <div style=" margin: 0; padding: 0;height: 100%;">
    <div style="display: flex;align-items: center;justify-content: center;background-color: white;height: 10vh;">
      <div style="width: 40vw;display: flex;justify-content: flex-end;align-items: center;">
        <!-- <img style="height: 70px;width: 70px;padding: 30px 0;margin-right: 40px;" src="../../static/emblem.png" /> -->
        <img src="../../static/logo.png" style="width: 300px;height: 30px;margin-right: 80px;"></img>
      </div>
      <div
        style="display: flex; align-items: center; justify-content: flex-start; width: 60vw; background-color: #d82832; height: 100%;">
        <div id="overview"
          style="margin-left: 120px; color: white; margin-top: 20px; cursor: pointer; position: relative;"
          @click="selectTab('overview')" :class="{ 'selected': selectedTab === 'overview' }">
          机构概况
          <div v-if="selectedTab === 'overview'" class="underline"></div>
        </div>
        <div id="contact"
          style="margin-left: 80px; color: white; margin-top: 20px; cursor: pointer; position: relative;"
          @click="selectTab('contact')" :class="{ 'selected': selectedTab === 'contact' }">
          联系我们
          <div v-if="selectedTab === 'contact'" class="underline"></div>
        </div>
      </div>
    </div>
    <div v-if="selectedTab === 'overview'" style="width: 100vw;">
      <img src="../../static/topImg.png" style="height: 35vh;width:100vw;" />
      <div style="width: 70vw;margin-left: 15vw;">
        <div style="font-size: 30px;padding: 30px 0;border-bottom: #e2cfcf 1px solid;">机构简介</div>
        <div style="display: flex;justify-content: center;align-items: center;">
          <img style="height: 120px;width: 120px;margin-right: 40px;" src="../../static/emblem.png" />
          <img style="height: 90px;width: 800px;padding: 30px 0;" src="../../static/logo.png" />
        </div>
        <div class="bgImg" style="padding-bottom: 30px;color: #616161;">
          <div style="text-indent: 4ch;line-height:40px">
            中国商业文化研究会百千万工程专业委员会是经中国商业文化研究会和各部委领导的指导下的成立的中国商业文化研究会分支机构。
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            中国商业文化研究会百千万工程专业委员会一级协会简介
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            中国商业文化研究会是经民政部登记注册、国务院国有资产监督管理委员会主管的全国性、学术性、非营利性社会组织，于1991年11月27日在北京成立。
            中国商业文化研究会以“探商道、树商誉、铸商魂”为崇高使命，以“诚信、责任、创新、共享”为基本理念和价值取向，以服务广大中小创业创新企业为职责担当，是我国商界领袖的文化俱乐部，是中华民族商业精神的共有家园，是企业家们创造与分享现代商业价值观念的神圣殿堂，是企业文化建设与评价的权威平台，是培育未来商业精英的示范基地。
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            中国商业文化研究会百千万工程专业委员会成立目的
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            2024年中央一号发布《中共中央国务院关于学习运用“千村示范、万村整治”工程经验有力有效推进乡村全面振兴的意见》明确表示我们要打好乡村振兴的漂亮仗，
            绘就宜居美业和美乡村新画卷，这也正是中国商业文化研究会百千万工程工作委员会的成立目的之一。
            同时中国商业文化研究会百千万工程工作委员会的成立，不仅旨在搭建一个集研究、交流、培训、咨询于一体的平台，
            通过深入研究城乡一体化发展政策体系，统筹推进城乡融合发展，服务于国家拓展发展空间、畅通经济循坏的大局，实现全体人民的共同富裕，
            又通过搭建一个助力高质量发展的专业互助平台，推动供给侧结构性改革，减少无效和低端供给，扩大有效和中高端供给，进而提高全要素生产率，
            加快建设农业强国，为更好的推动中国式现代化建设提供有力支撑。
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            中国商业文化研究会百千万工程专业委员会成立意义
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            1.确保重要农产品生产效率，解决农户的产品销售问题，提高乡村产业发展水平。
            中国商业文化研究会百千万工程工作委员会的成立能够极大的帮助农户入驻中诚亿家课题（杭州）商业管理有限公司旗下的亿家千城平台，
            释放县乡发展活力潜能，给农户带来极大的便利和利润，带动乡村经济，进而推动农业农村现代化，
            缩小城乡贫富差距，逐步实现全体人民共同富裕。
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            2.强化农业科技支撑，提高农业基础设施建设，坚持不懈夯实农业基础，推进乡村全面振兴。
            中国商业文化研究会百千万工程工作委员会的成立能够帮助农户配备最先进的科技，实施最省时省力的方案策略，
            使得基层农技推广体系条件建设更健全，公益性服务功能更完善，进而推进更深层次的区域经济合作，
            文化交流，助力农业高质量发展，实现乡村全面振兴。
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            3. 响应国家政策，推进产业结构性转型，提升乡村产业发展水平，提升乡村建设水平，提升乡村治理水平，
            以农业现代化助力全面建设社会主义现代化国家，2024年中共中央国务院发布的一号文件明确聚焦乡村振兴工作，推进乡村全面振兴。
            作为国家政策执行者的一份子，中国商业文化研究会百千万工程工作委员会的成立是行动，是落实，是前进，是产业结构性转型的有利途径。
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            中国商业文化研究会百千万工程专业委员会今后工作方向
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            中国商业文化研究会百千万工程工作委员会正式成立后，在中国商业文化研究会的领导和业务部门的指导下，
            认真遵守《中国商业文化研究会章程》和《中国商业文化研究会分支机构管理办法》，严格规范组织和活动行为，主要在以下几个方面开展工作：
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            1. 深入研究农业建设、乡村振兴战略和相关区县发展政策，努力构建“1＋N＋X”的策略，助力百千万工程走实落实。
            百千万工程工作委员会将持续关注国家区县发展政策的变化，深入研究各区县发展相关的法规的实施细则和影响，
            为企业提供专业的政策解读和咨询服务，为全体人民解决难题，增进社会福祉，促进社会进步。
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            2. 定期开展产业结构性转型与供给侧深化改革研讨会或交流活动，邀请国内知名专家学者进行分享和交流，
            明确农业作为第一产业是国民经济的基础，优化资源配置是供给侧深化改革的重点，培养高精尖人才是推动产业升级的重要支撑。
            致力于促进经济社会持续健康发展，更好的满足广大人民日益增长、不断升级和个性化的美好生活需要，实现乡村全面振兴，实现全体人民共同富裕。
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            3. 以创新思维、技术和方式带动乡村产业、文化、人才等各环节的全面振兴，推动百千万工程的创新发展，
            充分发挥乡镇连接城市与农村的纽带作用。一方面坚持因地制宜，整合农村分散资源，推进农村特色创新创业园区，
            孵化实训基地建设，吸引更多创新资源。另一方面要让农户掌握先进农业技术，给农业插上科技的翅膀。例如在农业生产领域，
            促进信息技术与农业的深度融合，提高农业生产水平。在农业销售领域，加强农产品仓储、物流等配套设施建设，
            培育农产品电商品牌，促进线上线下渠道融合发展，为乡村振兴注入新的动力，谱写新时代“三农”工作新篇章。
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            4. 加强与各级部门、各领域企业的合作，搭建各级部门和企业联系互动的大平台，
            探索“企业牵头+乡村开发+模式研究+综合运营”的乡村振兴新模式，提高县乡和农产品知名度或影响力，
            从而实现乡村产业振兴，全面振兴，共同为中国的明天贡献思想和行动的力量。
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            总之，中国商业文化研究会百千万工程工作委员会的成立，将为中国式现代化建设的研究、交流、培训和咨询提供一个全新的平台，
            推动百千万工程的创新发展，服务于国家拓展发展空间、畅通经济循坏的大局。未来，
            百千万工程工作委员会将继续秉承“研究、交流、培训、咨询”的宗旨，为乡村全面振兴和全体人民共同富裕贡献自己的力量。
          </div>
          <!-- <div style="text-indent: 4ch;line-height:40px">
            机构主要负责人
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            会长：
          </div>
          <div style="text-indent: 4ch;line-height:40px">
            副会长：
          </div> -->
        </div>
      </div>
    </div>
    <div v-else>
      <img src="../../static/topImg2.png" style="height: 35vh;width:100vw;" />
      <div style="height:80vh;width: 100vw;display: flex;justify-content: center;align-items: center;">
        <div style="width: 50vw;display: flex;justify-content: flex-end;align-items: center;">
          <img src="../../static/map.png" style="height: 65vh;width:42vw;" />
        </div>
        <div
          style="display: flex;flex-direction: column;justify-content:center;align-items: flex-start;width: 50vw;padding-left: 6vw;height: 50vh;">
          <div style="font-weight: bolder;font-size: 20px;">中国商业文化研究会百千万工程专业委员会</div>
          <div style="display: flex;align-items: center;">
            <div style="margin-top: 10px;padding: 3vh 0;">手机号：</div>
            <div style="color: #d82832;font-size: 30px;font-weight: bolder;">15058821818</div>
          </div>
          <div>地址：浙江省嘉兴市海宁市人民路94号</div>
          <div style="margin: 3vh 0;">email：298315860@qq.con</div>
        </div>
      </div>
    </div>
    <div
      style="height: 10vh;width: 100vw;background-color: #f4f4f4;display: flex;align-items: center;justify-content: center;">
      <div style="display: flex;flex-direction: column;justify-content: center;font-size: 10px;align-items: center;">
        <div style="color: black;">版权归中国商业文化研究会百千万工程专业委员会所有</div>
        <div style="display: flex;align-items: center;color: black;">
          <div style="display: flex;align-items: center;">
            <a href="http://www.bjjubao.org/node_1527.htm" class="bjjubao">
              北京市互联网违法和不良信息举报中心
            </a>
          </div>
        </div>

        <div style="color: black;">免责声明：任何单位或个人认为通过本网站网页内容可能涉嫌侵犯其著作权，应该及时向我们提出书面权利通知，并提供身份证明、权属证明及详细侵权情况证明。</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'bqw',
    data() {
      return {
        msg: 'Welcome to bqw',
        selectedTab: 'overview' // 默认选中的标签
      }
    },
    methods: {
      selectTab(tab) {
        this.selectedTab = tab;
      }
    }
  }
</script>

<style scoped>
  .underline {
    position: absolute;
    bottom: -6px;
    /* 调整横线位置 */
    left: 0;
    width: 100%;
    height: 2px;
    background-color: white;
  }

  .selected {
    font-weight: bold;
    /* 可选：选中时加粗 */
  }

  .internetContentProvider {
    text-decoration-line: none;
    color: black;
    margin-right: 10px;
  }

  .internetContentProvider:hover {
    text-decoration: underline;
  }

  .bjjubao {
    text-decoration-line: none;
    color: royalblue;
  }

  .bjjubao:hover {
    text-decoration: underline;
  }

  .bgImg {
    /* background-image: url(../../static/emblem.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain; */
  }
</style>



// WEBPACK FOOTER //
// src/components/bqw.vue